import React from 'react';

import ComparisonTable from 'common/Table/ComparisonTable';
import { CmiDigestWatchlistFeeComparison, CmiDigestWatchlistFeeComparisonRow } from 'types/cmiDigestWatchlist';

const FEE_FIELDS: { key: keyof CmiDigestWatchlistFeeComparisonRow; title: string }[] = [
  { key: 'community_fee', title: 'Community Fee' },
  { key: 'second_person_fee', title: 'Second Person Fee' },
  { key: 'pet_fee', title: 'Pet Fee' },
];

type Props = {
  careTypes: CmiDigestWatchlistFeeComparison[];
};

const CommunitiesToWatchFeeComparisonTable = ({ careTypes }: Props) => (
  <ComparisonTable<CmiDigestWatchlistFeeComparisonRow, CmiDigestWatchlistFeeComparison>
    careTypes={careTypes}
    getValueColumns={() =>
      FEE_FIELDS.map((field) => ({
        key: field.key,
        title: field.title,
        getValue: (row) => (row[field.key] as number | null) ?? null,
      }))
    }
  />
);

export default CommunitiesToWatchFeeComparisonTable;
